import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Link } from "react-scroll";
import {FaCode } from "react-icons/fa";

export default function HomeDropDown() {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="flex items-center border-b-2 border-white hover:border-sky-800 transition-all dark:hover:border-sky-500 dark:hover:border-b-2 mx-3 py-1 dark:border-b-2 dark:border-primary">
          Home
          <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="w-[620px] h-[450px] absolute left-0 z-10 mt-2 origin-top-right rounded-md shadow-xl shadow-gray-400 dark:shadow-gray-700 bg-gray-200 dark:bg-gray-800/80 backdrop-blur-md">
          <div className="p-3 grid gap-3 md:grid-cols-2 h-full">
            <div className="flex flex-col">
              <Link
                to="team"
                smooth="true"
                spy="true"
                className="bg-primary cursor-pointer h-[280px] py-7 hover:bg-gray-800 transition-all rounded-md flex flex-col items-center justify-center p-2"
              >
                {/* <img src="/img/logoSolo.png" className="w-16" alt="" /> */}
                <FaCode className="w-16" />
                <h1 className="font-semibold text-lg mt-3 mb-1 text-white dark:text-sky-400">
                  Team
                </h1>
                <p className="text-gray-300 text-sm text-center">
                  Meet our rockstars, who work day and night for the community
                </p>
              </Link>
              <Link
                to="roadmap"
                smooth="true"
                spy="true"
                className="bg-primary cursor-pointer h-[135px] mt-3 hover:bg-gray-800 transition-all rounded-md p-3 "
              >
                <h1 className="font-semibold mb-1 text-white dark:text-sky-400">
                  Road Map
                </h1>
                <p className="text-gray-300 text-sm">
                 Want to know our plans? Have a look at our road map
                </p>
              </Link>
            </div>
            <div className="grid gap-3 md:grid-rows-3">
              <Link
                to="contact"
                smooth="true"
                spy="true"
                className="bg-primary cursor-pointer hover:bg-gray-800 transition-all rounded-md p-3 "
              >
                <h1 className="font-semibold mb-1 text-white dark:text-sky-400">
                  Contact
                </h1>
                <p className="text-gray-300 text-sm">
                 Have a query or need an advice? get in touch with us.
                </p>
              </Link>
              <Link
                to="recentevents"
                smooth="true"
                spy="true"
                className="bg-primary cursor-pointer hover:bg-gray-800 transition-all rounded-md p-3 "
              >
                <h1 className="font-semibold mb-1 text-white dark:text-sky-400">
                  Events
                </h1>
                <p className="text-gray-300 text-sm">
                 Explore our recent events and know more about GDSC UIT
                </p>
              </Link>
              <Link
                to="mission&vision"
                smooth="true"
                spy="true"
                className="bg-primary cursor-pointer hover:bg-gray-800 transition-all rounded-md p-3 "
              >
                <h1 className="font-semibold mb-1 text-white dark:text-sky-400">
                  Mission & Vision
                </h1>
                <p className="text-gray-300 text-sm">
                  Check out our mission, what we do and our vision.
                </p>
              </Link>
            </div>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
